import {Tag} from "antd";
import React from "react";
import {Spacer} from "../../../../../../components/DesignSystem/Spacer/Spacer";
import {EditOutlined} from "@ant-design/icons";


export const FiltersPanel = ({filters, onDeleteFilter, onEditFilter}) => {

    return <div>
        <Spacer border={true}/>
        {filters.map((filter, index) => {
            return <Tag key={index} bordered={false} closable onClose={e => {
                e.preventDefault();
                onDeleteFilter(index)
            }}
            >
                <strong>{filter.column}</strong> {filter.operator} <strong>{filter.value}</strong>
                <span style={{color: "grey", fontSize: '10px', textAlign: 'center'}}>&nbsp;&nbsp;<EditOutlined onClick={e => onEditFilter(index)}/></span></Tag>
        })}
    </div>

}